'use strict';

import { IoBarcodeOutline } from 'react-icons/io5';
import EtablishmentIcon from 'Icons/EtablishmentIcon';
import SubscriptionIcon from 'Icons/SubscriptionIcon';
import StatisticsIcon from 'Icons/StatisticsIcon';
import CoworkingIcon from 'Icons/CoworkingIcon';
import CalendarIcon from 'Icons/CalendarIcon';
import ScheduleIcon from 'Icons/ScheduleIcon';
import BookingIcon from 'Icons/BookingIcon';
import ServiceIcon from 'Icons/ServiceIcon';
import CheckInIcon from 'Icons/CheckInIcon';
import CompanyIcon from 'Icons/CompanyIcon';
import UserIcon from 'Icons/UserIcon';
import EuroIcon from 'Icons/EuroIcon';
import NewsIcon from 'Icons/NewsIcon';
export const admin_links = {
  etablishments: {
    action: 'AdminEtablishmentsDashboard',
    label: 'Etablissements',
    icon: EtablishmentIcon
  },
  news: {
    action: 'AdminNewsDashboard',
    label: 'Actualités',
    icon: NewsIcon
  },
  servicetitles: {
    action: 'AdminServiceTitlesDashboard',
    label: 'Titres des services',
    icon: ServiceIcon
  },
  booking: {
    action: 'AdminBookingsDashboard',
    label: 'Réservations',
    icon: BookingIcon
  },
  b2b: {
    label: 'B2B',
    url: '/b2b',
    icon: CompanyIcon,
    sub_items: {
      companies: {
        action: 'AdminCompaniesDashboard',
        label: 'Entreprises'
      },
      packs: {
        action: 'AdminPacksDashboard',
        label: 'Catalogue des packs'
      },
      orders: {
        action: 'AdminPackOrdersDashboard',
        label: 'Commandes'
      },
      packorders_index: {
        action: 'AdminPackOrdersIndexDashboard',
        label: 'Packs achetés'
      },
      b2b_booking: {
        action: 'AdminB2BBookingsDashboard',
        label: 'Réservations B2B'
      }
    }
  },
  users: {
    action: 'AdminUsersDashboard',
    label: 'Utilisateurs',
    icon: UserIcon
  },
  admin_pre_bookings: {
    label: 'Offline',
    url: '/offline',
    icon: BookingIcon,
    sub_items: {
      admin_bookings: {
        action: 'AdminBookingsModuleDashboard',
        label: 'Gestion',
        icon: BookingIcon
      },
      subscription: {
        action: 'PreSubscriptionsDashboard',
        label: 'Abonnements',
        icon: SubscriptionIcon
      },
      admin_bookings_stats: {
        action: 'AdminBookingsStats',
        label: 'Indicateurs',
        icon: StatisticsIcon
      }
    }
  },
  discount_code: {
    label: 'Codes promo',
    action: 'DiscountCodesDashboard',
    icon: IoBarcodeOutline
  }
};
export const super_admin_links = {
  super_admin: {
    label: 'Super admin',
    url: '/super-admin',
    icon: UserIcon,
    sub_items: {
      etablishment_form: {
        label: 'Mon établissement',
        icon: EtablishmentIcon
      },
      coworkingspaces: {
        action: 'AdminCoworkingSpacesDashboard',
        label: 'Mes espaces',
        icon: CoworkingIcon
      },
      price_configuration: {
        action: 'PriceConfigurationDashboard',
        label: 'Gestion des prix',
        icon: EuroIcon
      },
      schedule_configuration_update: {
        url: '/disponibilites/gestion',
        label: 'Gestion disponibilités',
        icon: CalendarIcon
      },
      schedule_configuration_display: {
        url: '/disponibilites/affichage',
        label: 'Disponibilités',
        icon: ScheduleIcon
      },
      booking: {
        action: 'SuperAdminBookingsDashboard',
        label: 'Réservations',
        icon: BookingIcon
      },
      b2b_booking: {
        action: 'SuperAdminB2BBookingsDashboard',
        label: 'Réservations B2B',
        icon: BookingIcon
      },
      arrivals: {
        action: 'AdminArrivalsDashboard',
        label: 'Arrivées du jour',
        icon: CheckInIcon
      },
      subscription: {
        action: 'AdminSubscriptionsDashboard',
        label: 'Abonnements',
        icon: SubscriptionIcon
      },
      service: {
        action: 'AdminServicesDashboard',
        label: 'Services',
        icon: ServiceIcon
      },
      news: {
        action: 'SuperAdminNewsDashboard',
        label: 'Actualités',
        icon: NewsIcon
      }
    }
  },
  super_indicators: {
    label: 'Indicateurs admin',
    url: '/super-admin-indicateurs',
    icon: StatisticsIcon,
    sub_items: {
      meeting_indicator: {
        action: 'SuperAdminMeetingIndicator',
        label: 'Meeting'
      },
      lounge_indicator: {
        action: 'SuperAdminLoungeIndicator',
        label: 'Lounge'
      },
      services_indicator: {
        action: 'SuperAdminServicesIndicator',
        label: 'Services'
      },
      discount_codes: {
        action: 'SuperAdminDiscountCodesIndicator',
        label: 'Codes promo'
      },
      global_indicator: {
        action: 'SuperAdminGlobalIndicator',
        label: 'Global'
      }
    }
  },
  booking: {
    action: 'AdminBookingsDashboard',
    label: 'Réservations',
    icon: BookingIcon
  },
  ...admin_links
};
export const hotelier_links = {
  etablishments: {
    label: 'Mon établissement',
    icon: EtablishmentIcon
  },
  coworkingspaces: {
    action: 'AdminCoworkingSpacesDashboard',
    label: 'Mes espaces',
    icon: CoworkingIcon
  },
  price_configuration: {
    action: 'PriceConfigurationDashboard',
    label: 'Gestion des prix',
    icon: EuroIcon
  },
  schedule_configuration_update: {
    url: '/disponibilites/gestion',
    label: 'Gestion des disponibilités',
    icon: CalendarIcon
  },
  schedule_configuration_display: {
    url: '/disponibilites/affichage',
    label: 'Disponibilités',
    icon: ScheduleIcon
  },
  booking: {
    action: 'AdminBookingsDashboard',
    label: 'Réservations',
    icon: BookingIcon
  },
  b2b_booking: {
    action: 'AdminB2BBookingsDashboard',
    label: 'Réservations B2B',
    icon: BookingIcon
  },
  arrivals: {
    action: 'AdminArrivalsDashboard',
    label: 'Arrivées du jour',
    icon: CheckInIcon
  },
  subscription: {
    action: 'AdminSubscriptionsDashboard',
    label: 'Abonnements',
    icon: SubscriptionIcon
  },
  service: {
    action: 'AdminServicesDashboard',
    label: 'Services',
    icon: ServiceIcon
  },
  news: {
    action: 'AdminNewsDashboard',
    label: 'Actualités',
    icon: NewsIcon
  },
  indicators: {
    label: 'Indicateurs',
    url: '/indicateurs',
    icon: StatisticsIcon,
    sub_items: {
      meeting_indicator: {
        action: 'MeetingIndicator',
        label: 'Meeting'
      },
      lounge_indicator: {
        action: 'LoungeIndicator',
        label: 'Lounge'
      },
      global_indicator: {
        action: 'GlobalIndicator',
        label: 'Global'
      },
      services_indicator: {
        action: 'ServicesIndicator',
        label: 'Services'
      }
    }
  }
};
export const marketing_links = {
  /* export_btoc:
  {
  	action: 'ExportBtoCMarketingDashboard',
  	label: 'Export BtoC',
  	icon: BookingIcon
  } */
};
export const company_links = {
  informations: {
    action: 'CompanyInformation',
    label: 'Informations',
    icon: CompanyIcon
  },
  buy_packs: {
    action: 'BuyPacks',
    label: 'Acheter des Packs'
  },
  packs: {
    action: 'MyPacks',
    label: 'Mes Packs'
  },
  orders: {
    action: 'MyOrders',
    label: 'Mes commandes'
  },
  bookings: {
    action: 'MyBookings',
    label: 'Mes réservations'
  }
};
const sidebar_config = {
  admin_links,
  super_admin_links,
  hotelier_links,
  marketing_links,
  company_links
};
export default sidebar_config;
